export const russiaRegionsOptions = [
  { label: "Москва", value: "Москва" },
  { label: "Санкт-Петербург", value: "Санкт-Петербург" },
  { label: "Московская область", value: "Московская область" },
  { label: "Ленинградская область", value: "Ленинградская область" },
  { label: "Краснодарский край", value: "Краснодарский край" },
  { label: "Ростовская область", value: "Ростовская область" },
  { label: "Свердловская область", value: "Свердловская область" },
  { label: "Челябинская область", value: "Челябинская область" },
  { label: "Татарстан", value: "Татарстан" },
  { label: "Башкортостан", value: "Башкортостан" },
  { label: "Самарская область", value: "Самарская область" },
  { label: "Нижегородская область", value: "Нижегородская область" },
  { label: "Волгоградская область", value: "Волгоградская область" },
  { label: "Пермский край", value: "Пермский край" },
  { label: "Красноярский край", value: "Красноярский край" },
  { label: "Новосибирская область", value: "Новосибирская область" },
  { label: "Омская область", value: "Омская область" },
  { label: "Алтайский край", value: "Алтайский край" },
  { label: "Иркутская область", value: "Иркутская область" },
  { label: "Приморский край", value: "Приморский край" },
  { label: "Хабаровский край", value: "Хабаровский край" },
  { label: "Сахалинская область", value: "Сахалинская область" },
  { label: "Калининградская область", value: "Калининградская область" },
  { label: "Мурманская область", value: "Мурманская область" },
  { label: "Архангельская область", value: "Архангельская область" },
  { label: "Вологодская область", value: "Вологодская область" },
  { label: "Костромская область", value: "Костромская область" },
  { label: "Тверская область", value: "Тверская область" },
  { label: "Ярославская область", value: "Ярославская область" },
  { label: "Ивановская область", value: "Ивановская область" },
  { label: "Владимирская область", value: "Владимирская область" },
  { label: "Рязанская область", value: "Рязанская область" },
  { label: "Тульская область", value: "Тульская область" },
  { label: "Брянская область", value: "Брянская область" },
  { label: "Смоленская область", value: "Смоленская область" },
  { label: "Калужская область", value: "Калужская область" },
  { label: "Орловская область", value: "Орловская область" },
  { label: "Псковская область", value: "Псковская область" },
  { label: "Курская область", value: "Курская область" },
  { label: "Белгородская область", value: "Белгородская область" },
  { label: "Воронежская область", value: "Воронежская область" },
  { label: "Липецкая область", value: "Липецкая область" },
  { label: "Тамбовская область", value: "Тамбовская область" },
  { label: "Пензенская область", value: "Пензенская область" },
  { label: "Ульяновская область", value: "Ульяновская область" },
  { label: "Саратовская область", value: "Саратовская область" },
  { label: "Астраханская область", value: "Астраханская область" },
  { label: "Республика Калмыкия", value: "Республика Калмыкия" },
  { label: "Ставропольский край", value: "Ставропольский край" },
  { label: "Кабардино-Балкарская Республика", value: "Кабардино-Балкарская Республика" },
  { label: "Карачаево-Черкесская Республика", value: "Карачаево-Черкесская Республика" },
  { label: "Северная Осетия — Алания", value: "Северная Осетия — Алания" },
  { label: "Ингушетия", value: "Ингушетия" },
  { label: "Чеченская Республика", value: "Чеченская Республика" },
  { label: "Дагестан", value: "Дагестан" },
  { label: "Чувашская Республика", value: "Чувашская Республика" },
  { label: "Марий Эл", value: "Марий Эл" },
  { label: "Мордовия", value: "Мордовия" },
  { label: "Кировская область", value: "Кировская область" },
  { label: "Удмуртская Республика", value: "Удмуртская Республика" },
  { label: "Оренбургская область", value: "Оренбургская область" },
  { label: "Курганская область", value: "Курганская область" },
  { label: "Тюменская область", value: "Тюменская область" },
  { label: "Ханты-Мансийский автономный округ — Югра", value: "Ханты-Мансийский автономный округ — Югра" },
  { label: "Ямало-Ненецкий автономный округ", value: "Ямало-Ненецкий автономный округ" },
  { label: "Томская область", value: "Томская область" },
  { label: "Кемеровская область", value: "Кемеровская область" },
  { label: "Республика Алтай", value: "Республика Алтай" },
  { label: "Республика Тыва", value: "Республика Тыва" },
  { label: "Республика Хакасия", value: "Республика Хакасия" },
  { label: "Забайкальский край", value: "Забайкальский край" },
  { label: "Бурятия", value: "Бурятия" },
  { label: "Якутия", value: "Якутия" },
  { label: "Магаданская область", value: "Магаданская область" },
  { label: "Чукотский автономный округ", value: "Чукотский автономный округ" },
  { label: "Камчатский край", value: "Камчатский край" },
  { label: "Амурская область", value: "Амурская область" },
  { label: "Еврейская автономная область", value: "Еврейская автономная область" },
  { label: "Ненецкий автономный округ", value: "Ненецкий автономный округ" },
  { label: "Крым", value: "Крым" },
  { label: "Севастополь", value: "Севастополь" },
  { label: "Донецкая Народная Республика", value: "Донецкая Народная Республика" },
  { label: "Луганская Народная Республика", value: "Луганская Народная Республика" },
  { label: "Херсонская область", value: "Херсонская область" },
  { label: "Запорожская область", value: "Запорожская область" },
];